import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="text-filter"
export default class extends Controller {
  static targets = ["input"]
  static values = {
    filterParam: String  // The parameter name for this text filter
  }
  
  static outlets = ["filters"]
  
  connect() {
    // Initialize controller
    this.filterParam = this.filterParamValue
    
    // Load value from URL params
    this.loadFromUrlParams()
  }
  
  // Load value from URL parameters
  loadFromUrlParams() {
    const params = new URLSearchParams(window.location.search)
    const value = params.get(this.filterParam)
    
    if (value) {
      this.inputTarget.value = value
      this.updateFilter(true) // true indicates this is initialization
    }
  }
  
  // Update the filter when the text input changes
  updateInput() {
    this.updateFilter()
  }
  
  // Handle blur event (when input loses focus)
  handleBlur() {
    // Update the filter with initializing=false to trigger form submission
    // This follows the same pattern as other filter controllers
    this.updateFilter()
    setTimeout(() => {
      this.filtersOutlet.applyChangesIfNeeded()
    }, 50)
  }
  
  // Send the current value to the filters controller
  updateFilter(initializing = false) {
    const value = this.inputTarget.value.trim()
    this.filtersOutlet.updateTextFilter(this.filterParam, value, initializing)
  }
  
  // Clear the input field
  clear() {
    this.inputTarget.value = ''
    this.updateFilter()
  }
}
